import * as React from "react";

import getGenePalette from "../getGenePalette";
import GeneSnpShapes from "../shared/GeneSnpShapes";
import { geneGroupProps } from "../shared/geneGroupProps";
import getGeneSnpCount from "../shared/getGeneSnpCount";

export const CardiometabolicOmega3DiagramContent = ({
  geneColors = {},
  expectedSnps = {},
  onGeneClick
}) => {
  const fads2 = getGenePalette(geneColors.FADS2);
  const fads1 = getGenePalette(geneColors.FADS1);

  return (
    <>
      <g id="diagram" clipPath="url(#clip1_18293_231785)">
        <rect width={1024} height={1240} transform="translate(0 142)" fill="white" />
        <g id="omega_3-diagram">
          <rect width={1024} height={1240} transform="translate(0 142)" fill="white" />
          <g id="lines">
            <path
              id="Vector"
              d="M512.658 382.7L512.658 382L511.258 382L511.258 382.7L511.958 382.7L512.658 382.7ZM511.958 575L516 568L507.917 568L511.958 575ZM511.958 382.7L511.258 382.7L511.258 568.7L511.958 568.7L512.658 568.7L512.658 382.7L511.958 382.7Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_2">
            <path
              id="Vector_2"
              d="M512.742 800.7L512.742 800L511.342 800L511.342 800.7L512.042 800.7L512.742 800.7ZM512.041 956L516.083 949L508 949L512.041 956ZM512.042 800.7L511.342 800.7L511.341 949.7L512.041 949.7L512.741 949.7L512.742 800.7L512.042 800.7Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_3">
            <mask id="path-19-inside-1_18293_231785" fill="white">
              <path d="M562 755L562 608L631 608L631 755L562 755Z" />
            </mask>
            <path
              d="M631 608L631.7 608L631.7 607.3L631 607.3L631 608ZM631 755L631 755.7L631.7 755.7L631.7 755L631 755ZM562 755L562 755.7L563.917 755.7L563.917 755L563.917 754.3L562 754.3L562 755ZM567.75 755L567.75 755.7L571.583 755.7L571.583 755L571.583 754.3L567.75 754.3L567.75 755ZM575.417 755L575.417 755.7L579.25 755.7L579.25 755L579.25 754.3L575.417 754.3L575.417 755ZM583.083 755L583.083 755.7L586.917 755.7L586.917 755L586.917 754.3L583.083 754.3L583.083 755ZM590.75 755L590.75 755.7L594.583 755.7L594.583 755L594.583 754.3L590.75 754.3L590.75 755ZM598.417 755L598.417 755.7L602.25 755.7L602.25 755L602.25 754.3L598.417 754.3L598.417 755ZM606.083 755L606.083 755.7L609.917 755.7L609.917 755L609.917 754.3L606.083 754.3L606.083 755ZM613.75 755L613.75 755.7L617.583 755.7L617.583 755L617.583 754.3L613.75 754.3L613.75 755ZM621.417 755L621.417 755.7L625.25 755.7L625.25 755L625.25 754.3L621.417 754.3L621.417 755ZM629.083 755L629.083 755.7L631 755.7L631 755L631 754.3L629.083 754.3L629.083 755ZM631 755L631.7 755L631.7 752.958L631 752.958L630.3 752.958L630.3 755L631 755ZM631 748.875L631.7 748.875L631.7 744.792L631 744.792L630.3 744.792L630.3 748.875L631 748.875ZM631 740.708L631.7 740.708L631.7 736.625L631 736.625L630.3 736.625L630.3 740.708L631 740.708ZM631 732.542L631.7 732.542L631.7 728.458L631 728.458L630.3 728.458L630.3 732.542L631 732.542ZM631 724.375L631.7 724.375L631.7 720.292L631 720.292L630.3 720.292L630.3 724.375L631 724.375ZM631 716.208L631.7 716.208L631.7 712.125L631 712.125L630.3 712.125L630.3 716.208L631 716.208ZM631 708.042L631.7 708.042L631.7 703.958L631 703.958L630.3 703.958L630.3 708.042L631 708.042ZM631 699.875L631.7 699.875L631.7 695.792L631 695.792L630.3 695.792L630.3 699.875L631 699.875ZM631 691.708L631.7 691.708L631.7 687.625L631 687.625L630.3 687.625L630.3 691.708L631 691.708ZM631 683.542L631.7 683.542L631.7 679.458L631 679.458L630.3 679.458L630.3 683.542L631 683.542ZM631 675.375L631.7 675.375L631.7 671.292L631 671.292L630.3 671.292L630.3 675.375L631 675.375ZM631 667.208L631.7 667.208L631.7 663.125L631 663.125L630.3 663.125L630.3 667.208L631 667.208ZM631 659.042L631.7 659.042L631.7 654.958L631 654.958L630.3 654.958L630.3 659.042L631 659.042ZM631 650.875L631.7 650.875L631.7 646.792L631 646.792L630.3 646.792L630.3 650.875L631 650.875ZM631 642.708L631.7 642.708L631.7 638.625L631 638.625L630.3 638.625L630.3 642.708L631 642.708ZM631 634.542L631.7 634.542L631.7 630.458L631 630.458L630.3 630.458L630.3 634.542L631 634.542ZM631 626.375L631.7 626.375L631.7 622.292L631 622.292L630.3 622.292L630.3 626.375L631 626.375ZM631 618.208L631.7 618.208L631.7 614.125L631 614.125L630.3 614.125L630.3 618.208L631 618.208ZM631 610.042L631.7 610.042L631.7 608L631 608L630.3 608L630.3 610.042L631 610.042ZM631 608L631 607.3L629.083 607.3L629.083 608L629.083 608.7L631 608.7L631 608ZM625.25 608L625.25 607.3L621.417 607.3L621.417 608L621.417 608.7L625.25 608.7L625.25 608ZM617.583 608L617.583 607.3L613.75 607.3L613.75 608L613.75 608.7L617.583 608.7L617.583 608ZM609.917 608L609.917 607.3L606.083 607.3L606.083 608L606.083 608.7L609.917 608.7L609.917 608ZM602.25 608L602.25 607.3L598.417 607.3L598.417 608L598.417 608.7L602.25 608.7L602.25 608ZM594.583 608L594.583 607.3L590.75 607.3L590.75 608L590.75 608.7L594.583 608.7L594.583 608ZM586.917 608L586.917 607.3L583.083 607.3L583.083 608L583.083 608.7L586.917 608.7L586.917 608ZM579.25 608L579.25 607.3L575.417 607.3L575.417 608L575.417 608.7L579.25 608.7L579.25 608ZM571.583 608L571.583 607.3L567.75 607.3L567.75 608L567.75 608.7L571.583 608.7L571.583 608ZM563.917 608L563.917 607.3L562 607.3L562 608L562 608.7L563.917 608.7L563.917 608ZM631 608L632.4 608L632.4 606.6L631 606.6L631 608ZM631 755L631 756.4L632.4 756.4L632.4 755L631 755ZM562 755L562 756.4L563.917 756.4L563.917 755L563.917 753.6L562 753.6L562 755ZM567.75 755L567.75 756.4L571.583 756.4L571.583 755L571.583 753.6L567.75 753.6L567.75 755ZM575.417 755L575.417 756.4L579.25 756.4L579.25 755L579.25 753.6L575.417 753.6L575.417 755ZM583.083 755L583.083 756.4L586.917 756.4L586.917 755L586.917 753.6L583.083 753.6L583.083 755ZM590.75 755L590.75 756.4L594.583 756.4L594.583 755L594.583 753.6L590.75 753.6L590.75 755ZM598.417 755L598.417 756.4L602.25 756.4L602.25 755L602.25 753.6L598.417 753.6L598.417 755ZM606.083 755L606.083 756.4L609.917 756.4L609.917 755L609.917 753.6L606.083 753.6L606.083 755ZM613.75 755L613.75 756.4L617.583 756.4L617.583 755L617.583 753.6L613.75 753.6L613.75 755ZM621.417 755L621.417 756.4L625.25 756.4L625.25 755L625.25 753.6L621.417 753.6L621.417 755ZM629.083 755L629.083 756.4L631 756.4L631 755L631 753.6L629.083 753.6L629.083 755ZM631 755L632.4 755L632.4 752.958L631 752.958L629.6 752.958L629.6 755L631 755ZM631 748.875L632.4 748.875L632.4 744.792L631 744.792L629.6 744.792L629.6 748.875L631 748.875ZM631 740.708L632.4 740.708L632.4 736.625L631 736.625L629.6 736.625L629.6 740.708L631 740.708ZM631 732.542L632.4 732.542L632.4 728.458L631 728.458L629.6 728.458L629.6 732.542L631 732.542ZM631 724.375L632.4 724.375L632.4 720.292L631 720.292L629.6 720.292L629.6 724.375L631 724.375ZM631 716.208L632.4 716.208L632.4 712.125L631 712.125L629.6 712.125L629.6 716.208L631 716.208ZM631 708.042L632.4 708.042L632.4 703.958L631 703.958L629.6 703.958L629.6 708.042L631 708.042ZM631 699.875L632.4 699.875L632.4 695.792L631 695.792L629.6 695.792L629.6 699.875L631 699.875ZM631 691.708L632.4 691.708L632.4 687.625L631 687.625L629.6 687.625L629.6 691.708L631 691.708ZM631 683.542L632.4 683.542L632.4 679.458L631 679.458L629.6 679.458L629.6 683.542L631 683.542ZM631 675.375L632.4 675.375L632.4 671.292L631 671.292L629.6 671.292L629.6 675.375L631 675.375ZM631 667.208L632.4 667.208L632.4 663.125L631 663.125L629.6 663.125L629.6 667.208L631 667.208ZM631 659.042L632.4 659.042L632.4 654.958L631 654.958L629.6 654.958L629.6 659.042L631 659.042ZM631 650.875L632.4 650.875L632.4 646.792L631 646.792L629.6 646.792L629.6 650.875L631 650.875ZM631 642.708L632.4 642.708L632.4 638.625L631 638.625L629.6 638.625L629.6 642.708L631 642.708ZM631 634.542L632.4 634.542L632.4 630.458L631 630.458L629.6 630.458L629.6 634.542L631 634.542ZM631 626.375L632.4 626.375L632.4 622.292L631 622.292L629.6 622.292L629.6 626.375L631 626.375ZM631 618.208L632.4 618.208L632.4 614.125L631 614.125L629.6 614.125L629.6 618.208L631 618.208ZM631 610.042L632.4 610.042L632.4 608L631 608L629.6 608L629.6 610.042L631 610.042ZM631 608L631 606.6L629.083 606.6L629.083 608L629.083 609.4L631 609.4L631 608ZM625.25 608L625.25 606.6L621.417 606.6L621.417 608L621.417 609.4L625.25 609.4L625.25 608ZM617.583 608L617.583 606.6L613.75 606.6L613.75 608L613.75 609.4L617.583 609.4L617.583 608ZM609.917 608L609.917 606.6L606.083 606.6L606.083 608L606.083 609.4L609.917 609.4L609.917 608ZM602.25 608L602.25 606.6L598.417 606.6L598.417 608L598.417 609.4L602.25 609.4L602.25 608ZM594.583 608L594.583 606.6L590.75 606.6L590.75 608L590.75 609.4L594.583 609.4L594.583 608ZM586.917 608L586.917 606.6L583.083 606.6L583.083 608L583.083 609.4L586.917 609.4L586.917 608ZM579.25 608L579.25 606.6L575.417 606.6L575.417 608L575.417 609.4L579.25 609.4L579.25 608ZM571.583 608L571.583 606.6L567.75 606.6L567.75 608L567.75 609.4L571.583 609.4L571.583 608ZM563.917 608L563.917 606.6L562 606.6L562 608L562 609.4L563.917 609.4L563.917 608Z"
              fill="#1A1A1A"
              mask="url(#path-19-inside-1_18293_231785)"
            />
          </g>
          <g id="lines_4">
            <path
              id="Vector_3"
              d="M512.7 591.7L512.7 730.3"
              stroke="#1A1A1A"
              strokeWidth={1.4}
              strokeLinecap="square"
            />
          </g>
          <g id="Frame 465">
            <path
              d="M336 202.7H688C694.241 202.7 699.3 207.759 699.3 214V370C699.3 376.241 694.241 381.3 688 381.3H336C329.759 381.3 324.7 376.241 324.7 370V214C324.7 207.759 329.759 202.7 336 202.7Z"
              stroke="#1A1A1A"
              strokeWidth={1.4}
            />
            <g id="Rich Text Block">
              <g id="Frame 483">
                <text
                  id="H2 Header"
                  fill="#1A1A1A"
                  style={{ whiteSpace: "pre" }}
                  xmlSpace="preserve"
                  fontFamily="Gilroy W05 Bold"
                  fontSize={24}
                  letterSpacing="0em"
                >
                  <tspan x={364.133} y={268.196}>
                    Alpha-Linolenic acid (ALA)
                  </tspan>
                </text>
                <text
                  id="H2 Header_2"
                  fill="#1A1A1A"
                  style={{ whiteSpace: "pre" }}
                  xmlSpace="preserve"
                  fontFamily="Gilroy W05 Regular"
                  fontSize={16}
                  letterSpacing="0em"
                >
                  <tspan x={474.047} y={297.44}>
                    (Precursor)
                  </tspan>
                </text>
              </g>
              <g id="Sources: Flaxseeds, chia seeds, walnuts">
                <text
                  fill="#1A1A1A"
                  style={{ whiteSpace: "pre" }}
                  xmlSpace="preserve"
                  fontFamily="Gilroy W05 Medium"
                  fontSize={16}
                  letterSpacing="0em"
                >
                  <tspan x={430.609} y={333.464}>
                    Flaxseeds, chia seeds, walnuts
                  </tspan>
                </text>
                <text
                  fill="#1A1A1A"
                  style={{ whiteSpace: "pre" }}
                  xmlSpace="preserve"
                  fontFamily="Gilroy W05 Bold"
                  fontSize={16}
                  letterSpacing="0em"
                >
                  <tspan x={364} y={333.464}>
                    {"Sources: "}
                  </tspan>
                </text>
              </g>
            </g>
          </g>
          <g id="Frame 466">
            <path
              d="M678.988 986V986.7H681C681.756 986.7 682.493 986.774 683.206 986.915L683.341 986.229C684.915 986.54 686.378 987.16 687.666 988.021L687.278 988.603C688.511 989.428 689.572 990.489 690.397 991.722L690.978 991.333C691.84 992.621 692.459 994.084 692.771 995.658L692.085 995.794C692.226 996.507 692.3 997.244 692.3 998V1000H693V1004H692.3V1008H693V1012H692.3V1016H693V1020H692.3V1024H693V1028H692.3V1032H693V1036H692.3V1040H693V1044H692.3V1048H693V1052H692.3V1056H693V1060H692.3V1064H693V1068H692.3V1072H693V1076H692.3V1080H693V1084H692.3V1088H693V1092H692.3V1096H693V1100H692.3V1104H693V1108H692.3V1112H693V1116H692.3V1120H693V1124H692.3V1128H693V1132H692.3V1136H693V1140H692.3V1144H693V1148H692.3V1152H693V1156H692.3V1160H693V1164H692.3V1168H693V1172H692.3V1176H693V1180H692.3V1184H693V1188H692.3V1192H693V1196H692.3V1200H693V1204H692.3V1208H693V1212H692.3V1216H693V1220H692.3V1224H693V1228H692.3V1232H693V1236H692.3V1238C692.3 1238.76 692.226 1239.49 692.085 1240.21L692.771 1240.34C692.459 1241.92 691.84 1243.38 690.978 1244.67L690.397 1244.28C689.572 1245.51 688.511 1246.57 687.278 1247.4L687.666 1247.98C686.378 1248.84 684.915 1249.46 683.341 1249.77L683.206 1249.08C682.493 1249.23 681.756 1249.3 681 1249.3H678.988V1250H674.964V1249.3H670.94V1250H666.916V1249.3H662.893V1250H658.869V1249.3H654.845V1250H650.821V1249.3H646.798V1250H642.773V1249.3H638.75V1250H634.726V1249.3H630.702V1250H626.679V1249.3H622.654V1250H618.631V1249.3H614.607V1250H610.583V1249.3H606.56V1250H602.535V1249.3H598.512V1250H594.488V1249.3H590.464V1250H586.44V1249.3H582.417V1250H578.393V1249.3H574.369V1250H570.345V1249.3H566.321V1250H562.298V1249.3H558.273V1250H554.25V1249.3H550.227V1250H546.202V1249.3H542.179V1250H538.154V1249.3H534.131V1250H530.107V1249.3H526.083V1250H522.06V1249.3H518.036V1250H514.012V1249.3H509.988V1250H505.964V1249.3H501.94V1250H497.917V1249.3H493.893V1250H489.869V1249.3H485.846V1250H481.821V1249.3H477.798V1250H473.773V1249.3H469.75V1250H465.727V1249.3H461.702V1250H457.679V1249.3H453.655V1250H449.631V1249.3H445.607V1250H441.583V1249.3H437.56V1250H433.536V1249.3H429.512V1250H425.488V1249.3H421.464V1250H417.44V1249.3H413.417V1250H409.393V1249.3H405.369V1250H401.346V1249.3H397.321V1250H393.298V1249.3H389.273V1250H385.25V1249.3H381.227V1250H377.202V1249.3H373.179V1250H369.154V1249.3H365.131V1250H361.107V1249.3H357.083V1250H353.06V1249.3H349.036V1250H345.012V1249.3H343C342.244 1249.3 341.507 1249.23 340.794 1249.08L340.658 1249.77C339.084 1249.46 337.621 1248.84 336.333 1247.98L336.722 1247.4C335.489 1246.57 334.428 1245.51 333.603 1244.28L333.021 1244.67C332.16 1243.38 331.54 1241.92 331.229 1240.34L331.915 1240.21C331.809 1239.67 331.741 1239.12 331.714 1238.56L331.7 1238V1236H331V1232H331.7V1228H331V1224H331.7V1220H331V1216H331.7V1212H331V1208H331.7V1204H331V1200H331.7V1196H331V1192H331.7V1188H331V1184H331.7V1180H331V1176H331.7V1172H331V1168H331.7V1164H331V1160H331.7V1156H331V1152H331.7V1148H331V1144H331.7V1140H331V1136H331.7V1132H331V1128H331.7V1124H331V1120H331.7V1116H331V1112H331.7V1108H331V1104H331.7V1100H331V1096H331.7V1092H331V1088H331.7V1084H331V1080H331.7V1076H331V1072H331.7V1068H331V1064H331.7V1060H331V1056H331.7V1052H331V1048H331.7V1044H331V1040H331.7V1036H331V1032H331.7V1028H331V1024H331.7V1020H331V1016H331.7V1012H331V1008H331.7V1004H331V1000H331.7V998C331.7 997.244 331.774 996.507 331.915 995.794L331.229 995.658C331.54 994.084 332.16 992.621 333.021 991.333L333.603 991.722C334.428 990.489 335.489 989.428 336.722 988.603L336.333 988.021C337.621 987.16 339.084 986.54 340.658 986.229L340.794 986.915C341.507 986.774 342.244 986.7 343 986.7H345.012V986H349.036V986.7H353.06V986H357.084V986.7H361.107V986H365.131V986.7H369.155V986H373.179V986.7H377.202V986H381.227V986.7H385.25V986H389.274V986.7H393.298V986H397.321V986.7H401.346V986H405.369V986.7H409.393V986H413.417V986.7H417.44V986H421.465V986.7H425.488V986H429.512V986.7H433.536V986H437.56V986.7H441.583V986H445.607V986.7H449.631V986H453.655V986.7H457.679V986H461.702V986.7H465.727V986H469.75V986.7H473.773V986H477.798V986.7H481.821V986H485.846V986.7H489.869V986H493.893V986.7H497.917V986H501.94V986.7H505.964V986H509.988V986.7H514.012V986H518.036V986.7H522.06V986H526.083V986.7H530.107V986H534.131V986.7H538.154V986H542.179V986.7H546.202V986H550.227V986.7H554.25V986H558.273V986.7H562.298V986H566.321V986.7H570.345V986H574.369V986.7H578.393V986H582.417V986.7H586.44V986H590.464V986.7H594.488V986H598.512V986.7H602.536V986H606.56V986.7H610.583V986H614.607V986.7H618.631V986H622.654V986.7H626.679V986H630.702V986.7H634.727V986H638.75V986.7H642.773V986H646.798V986.7H650.821V986H654.846V986.7H658.869V986H662.893V986.7H666.917V986H670.94V986.7H674.964V986H678.988Z"
              stroke="#5220DD"
              strokeWidth={1.4}
              strokeDasharray="4 4"
            />
            <g id="report-label">
              <g id="Report titles">
                <rect width={42} height={36} transform="translate(491 1026)" fill="white" />
                <text
                  id="25-Hydroxy Vitamin D"
                  fill="#1A1A1A"
                  style={{ whiteSpace: "pre" }}
                  xmlSpace="preserve"
                  fontFamily="Gilroy W05 Bold"
                  fontSize={24}
                  letterSpacing="0em"
                >
                  <tspan x={491.398} y={1052.2}>
                    EPA
                  </tspan>
                </text>
              </g>
              <g id="lines_5">
                <path
                  id="Vector_4"
                  d="M512.658 1066.7L512.658 1066L511.258 1066L511.258 1066.7L511.958 1066.7L512.658 1066.7ZM511.958 1136L516 1129L507.917 1129L511.958 1136ZM511.958 1066.7L511.258 1066.7L511.258 1129.7L511.958 1129.7L512.658 1129.7L512.658 1066.7L511.958 1066.7Z"
                  fill="#1A1A1A"
                />
              </g>
            </g>
            <g id="Report titles_2">
              <rect width={282} height={64} transform="translate(371 1146)" fill="white" />
              <text
                id="25-Hydroxy Vitamin D_2"
                fill="black"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Bold"
                fontSize={24}
                letterSpacing="0em"
              >
                <tspan x={487.449} y={1172.2}>
                  DHA
                </tspan>
              </text>
              <g id="Sub label">
                <text
                  fill="#1A1A1A"
                  style={{ whiteSpace: "pre" }}
                  xmlSpace="preserve"
                  fontFamily="Gilroy W05 Regular"
                  fontSize={16}
                  letterSpacing="0em"
                >
                  <tspan x={480.422} y={1201.46}>
                    {" "}
                    Fatty fish, supplements
                  </tspan>
                </text>
                <text
                  fill="#1A1A1A"
                  style={{ whiteSpace: "pre" }}
                  xmlSpace="preserve"
                  fontFamily="Gilroy W05 Bold"
                  fontSize={16}
                  letterSpacing="0em"
                >
                  <tspan x={371.438} y={1201.46}>
                    Direct sources:
                  </tspan>
                </text>
              </g>
            </g>
          </g>
          <g id="Report titles_3">
            <rect width={138} height={28} transform="translate(657 670)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_3"
              fill="#1A1A1A"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={18}
              letterSpacing="0em"
            >
              <tspan x={657.059} y={690.129}>
                Sequential order
              </tspan>
            </text>
          </g>
          <g id="Report titles_4">
            <rect width={42} height={20} transform="translate(400 592)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_4"
              fill="#1A1A1A"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={12}
              letterSpacing="0px"
            >
              <tspan x={400.48} y={606.086}>
                Phase 1
              </tspan>
            </text>
          </g>
          <g id="Report titles_5">
            <rect width={44} height={20} transform="translate(400 735)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_5"
              fill="#1A1A1A"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={12}
              letterSpacing="0px"
            >
              <tspan x={400.455} y={749.086}>
                Phase 2
              </tspan>
            </text>
          </g>
          <g id="gene-FADS2" {...geneGroupProps("FADS2", onGeneClick)}>
            <g id="gene-lozenge_5">
              <path
                d="M456 590C456 587.791 457.791 586 460 586H554C556.209 586 558 587.791 558 590V626C558 628.209 556.209 630 554 630H460C457.791 630 456 628.209 456 626V590Z"
                fill={fads2.lozengeFill}
              />
              <text
                id="gene-label_5"
                fill="black"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Regular"
                fontSize={24}
                letterSpacing="0em"
              >
                <tspan x={472.078} y={616.16}>
                  FADS2
                </tspan>
              </text>
            </g>
            <GeneSnpShapes
              id="fads2"
              groupId="gene-snps"
              genePalette={fads2}
              startX={464}
              startY={632}
              snpCount={getGeneSnpCount("FADS2", expectedSnps, geneColors)}
            />
          </g>
          <g id="gene-FADS1" {...geneGroupProps("FADS1", onGeneClick)}>
            <g id="gene-lozenge_6">
              <path
                d="M456 735C456 732.791 457.791 731 460 731H552C554.209 731 556 732.791 556 735V771C556 773.209 554.209 775 552 775H460C457.791 775 456 773.209 456 771V735Z"
                fill={fads1.lozengeFill}
              />
              <text
                id="gene-label_6"
                fill="black"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Regular"
                fontSize={24}
                letterSpacing="0em"
              >
                <tspan x={473.305} y={761.16}>
                  FADS1
                </tspan>
              </text>
            </g>
            <GeneSnpShapes
              id="fads1"
              groupId="gene-snps_2"
              genePalette={fads1}
              startX={464}
              startY={777}
              snpCount={getGeneSnpCount("FADS1", expectedSnps, geneColors)}
            />
          </g>
        </g>
      </g>
    </>
  );
};

const SvgCardiometabolicOmega3Diagram = ({
  geneColors = {},
  expectedSnps = {},
  onGeneClick,
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={1024}
    height={1240}
    viewBox="0 142 1024 1240"
    fill="none"
    {...props}
  >
    <CardiometabolicOmega3DiagramContent
      geneColors={geneColors}
      expectedSnps={expectedSnps}
      onGeneClick={onGeneClick}
    />
    <defs>
      <clipPath id="clip0_18293_231785">
        <rect width={1024} height={1382} fill="white" />
      </clipPath>
      <clipPath id="clip1_18293_231785">
        <rect width={1024} height={1240} fill="white" transform="translate(0 142)" />
      </clipPath>
    </defs>
  </svg>
);

export default SvgCardiometabolicOmega3Diagram;
